/**
 * DO NOT MODIFY, your changes will be lost on next generation!
 * Generated code from template "model.velocity"
 */

/**
 * THIS Template MUST remain FRAMEWORK INDEPENDENT!! It is used for Angular, Ionic, Node-Express... any JavaScript framework
 */

/* tslint:disable */
import { ValueOfList } from './value-of-list.model';


export class LegalForm extends ValueOfList {
    id?: number; // ecf001


    // <editor-fold desc="From and To Json Methods" defaultstate="collapsed">
/**
 * DO NOT MODIFY, your changes will be lost on next generation!
 * Generated code from template &quot;model-json.velocity&quot;
 */

    /** ---- Generated part from .\ang-man\src\modules\generator\writers\common\templates\model-json.velocity */

    public static mergeJSON(instance: any, data: any): LegalForm {
        if (!data) { return instance; }
        ValueOfList.mergeJSON(instance, data);
        if (data.id != null) {instance.id = data.id; }
        return instance; // ir
    }

    public fromJSON(data: any): this { // cbn001
        return LegalForm.mergeJSON(this, data) as any;
    }

    public static mergeJSONFromObject(target: any, object: LegalForm) {
        ValueOfList.mergeJSONFromObject(target, object);
        // TODO: mapping
        return object;
    }

    // toJSON ensures that only class-defined fields are exported.
    public toJSON() {
        return LegalForm.mergeJSONFromObject({}, this);
    }

    // Compares this AppInfo instance with another AppInfo instance, recursively.
    // Transient fields are not considered.
    public equals(other: LegalForm): boolean {
        return JSON.stringify(this.toJSON()) === JSON.stringify(other.toJSON());
    }

    /** ---- */


/** end of template &quot;model-json.velocity&quot; */

    // </editor-fold>

}


/** end of template "model.velocity" */
